var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "act_plus",
    d: "M16.2692 12.8425L16.2689 1.20968C16.2688 0.889575 16.1435 0.587681 15.9159 0.359647C15.688 0.13174 15.3859 0.00615124 15.0658 0.00653056L14.0465 0.00665763C13.7258 0.00640463 13.4243 0.13212 13.1962 0.360153C12.9686 0.587808 12.8429 0.889322 12.8431 1.21006L12.843 12.8425L1.21027 12.8429C0.88978 12.8424 0.588139 12.9683 0.360232 13.1962C0.132578 13.4238 0.00673605 13.7255 0.00724193 14.0459L0.00686248 15.0655C0.00686254 15.7292 0.546655 16.269 1.21001 16.2686L12.843 16.2687L12.8429 27.9015C12.8431 28.222 12.9686 28.5237 13.1964 28.7515C13.4242 28.9793 13.7259 29.1047 14.0463 29.1049L15.0657 29.1046C15.386 29.105 15.6879 28.9792 15.9154 28.7516C16.1433 28.5237 16.2691 28.222 16.2687 27.9016L16.2689 16.2687H27.9015C28.2222 16.2689 28.5238 16.1433 28.7515 15.9156L28.7517 15.9154C28.9795 15.6876 29.1051 15.3859 29.1049 15.0653L29.1051 14.0461C29.1049 13.726 28.9795 13.4239 28.7517 13.1962C28.5239 12.9684 28.222 12.843 27.9018 12.8428L16.2692 12.8425Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActPlusWhite);
export default __webpack_public_path__ + "static/media/act_plus_white.94b6816d6ab1b86502d2336069cdb9f6.svg";
export { ForwardRef as ReactComponent };